import { lazy } from 'react';
import { authRoles } from 'app/auth';

const OrderAppConfig = {
	settings: {
		layout: {}
	},
	auth: [...authRoles.diller, ...authRoles.dillerHelper],
	routes: [
		{
			path: '/apps/diller/sa-orders',
			exact: true,
			component: lazy(() => import('./single/Data'))
		},

		{
			path: '/apps/diller/sa-orders/:id/:status',
			exact: true,
			component: lazy(() => import('./order'))
		},
		{
			path: '/apps/diller/sa-orders/:orderId/:requestId',
			exact: true,
			component: lazy(() => import('./products'))
		}
	]
};

export default OrderAppConfig;
